import { types } from 'mobx-state-tree';

const Transaction = types.model('Transaction', {
  accountId: types.string,
  name: types.string,
  path: types.string,
  createDate: types.string,
  id: types.number,
})
// .views(self => ({
// }));

export default Transaction;
